import script from "./customDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./customDropdown.vue?vue&type=script&setup=true&lang=js"

import "./customDropdown.vue?vue&type=style&index=0&id=468c2a5e&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-468c2a5e"]])

export default __exports__